import { configureStore } from "@reduxjs/toolkit";
import loginReducer from './features/LoginSlice';
import feedbackFormReducer from './features/FeedbackFormSlice';

export const store = configureStore({
    reducer: {
        login: loginReducer,
        feedbackForm:  feedbackFormReducer,
    }
})